const Y_AXIS_MIN_RATIO = 0.95;

export const getChartYAxisMin = (...series: number[][]) => {
	const allValues = series.flat();

	if (allValues.length === 0) {
		return undefined;
	}

	const dataMin = Math.min(...allValues);

	if (dataMin <= 0) {
		return undefined;
	}

	return Math.floor(dataMin * Y_AXIS_MIN_RATIO);
};
